import { createSelector } from 'reselect'

const getNurtureAnalytics = (state: any) => state.nurtureAnalytics

export const selectNurtureAnalytics = createSelector(
  getNurtureAnalytics,
  (data) => data || null
)

export const selectNurtureAnalyticsData = createSelector(
  getNurtureAnalytics,
  (data) => (data && data.data ? data.data : [])
)

export const selectNurtureAnalyticsStats = createSelector(
  getNurtureAnalytics,
  (data) => (data && data.stats ? data.stats : null)
)

export const selectNurtureAnalyticsLoading = createSelector(
  getNurtureAnalytics,
  (data) => (data ? data.loading : false)
)

export const selectNurtureAnalyticsError = createSelector(
  getNurtureAnalytics,
  (data) => (data ? data.error : null)
)

export const selectNurtureAnalyticsUiState = createSelector(
  getNurtureAnalytics,
  (data) => (data ? data.uiState : 'DISABLED')
)

export const selectNurtureAnalyticsDownloadInProgress = createSelector(
  getNurtureAnalytics,
  (data) => (data ? data.downloadInProgress : false)
)

export const selectNurtureAnalyticsDownloadError = createSelector(
  getNurtureAnalytics,
  (data) => (data ? data.downloadError : null)
)
